import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import RouterConfig from './router';
import { createRoot } from 'react-dom/client';

const root = createRoot(document.getElementById('root')); // createRoot(container!) if you use TypeScript
root.render(<RouterConfig />);
